export interface ErrorState {
  isError: boolean;
  field?: string;
  message: string;
}

export enum EnumErrorCodeRequest {
  GENERIC_ERROR = "generic_error",
  PROTOCOL_NOT_FOUND = "protocol_not_found",
  INVALID_TOKEN = "invalid_token"
}
export interface ButtonGridItemProps {
  isActive?: () => boolean;
}

export interface RouteParams {
  protocolId: string;
}

export let credentials = {
  access_token: "",
  pipefy_token: "",
  expires_in: 0,
  refresh_expires_in: 0,
  refresh_token: "",
  token_type: "",
  "not-before-policy": 0,
  session_state: "",
  scope: "",
};
